import React from 'react';

const Terms = () => (
  <div className="max-w-3xl mx-auto px-4 py-16 text-text-primary">
    <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
    <p className="mb-4">Welcome to AtlasMoth! By accessing or using our website, you agree to the following terms and conditions.</p>
    <h2 className="text-xl font-semibold mt-8 mb-2">Use of Content</h2>
    <ul className="list-disc ml-6 mb-4">
      <li>All content is for informational purposes only and may not be copied or redistributed without permission.</li>
      <li>You may not use our website for any unlawful or harmful activities.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-8 mb-2">Newsletter & Communication</h2>
    <ul className="list-disc ml-6 mb-4">
      <li>By subscribing to our newsletter, you consent to receive emails from AtlasMoth. You can unsubscribe at any time.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-8 mb-2">Limitation of Liability</h2>
    <ul className="list-disc ml-6 mb-4">
      <li>AtlasMoth is not liable for any damages resulting from the use of our website or content.</li>
      <li>We do not guarantee the accuracy or completeness of information on our site.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-8 mb-2">Changes to Terms</h2>
    <p className="mb-4">We may update these Terms of Service at any time. Continued use of the site constitutes acceptance of any changes.</p>
    <h2 className="text-xl font-semibold mt-8 mb-2">Contact</h2>
    <p>If you have questions, contact us at <a href="mailto:kbaid@atlasmoth.com" className="underline">kbaid@atlasmoth.com</a>.</p>
    <p className="mt-8 text-xs text-text-secondary">Last updated: June 15, 2025</p>
  </div>
);

export default Terms;
